// extracted by mini-css-extract-plugin
export default {"wrapper":"AnswerHorizontal_wrapper__Cv+qt","titles":"AnswerHorizontal_titles__G3USy","contentImg":"AnswerHorizontal_contentImg__M5o1m"};